import { isDesktop, isIE } from 'react-device-detect';
import { cloneDeepWith } from 'lodash';
import { hasKey } from '@/utils/resultsHelper';
import { containerShell } from './constants';

export const layoutSettings = (content) => ({
  settings: {
    hasHeaders: true,
    constrainDragToContainer: true,
    reorderEnabled: !isIE && isDesktop,
    selectionEnabled: true,
    showPopoutIcon: false,
    showMaximiseIcon: isDesktop,
    showCloseIcon: isDesktop,
  },
  dimensions: {
    borderWidth: 7,
    minItemHeight: 200,
    minItemWidth: 200,
    headerHeight: 30,
    dragProxyWidth: 300,
    dragProxyHeight: 200,
  },
  ...content,
});

const basicStack = () => ({ type: 'stack', content: [] });

const emptyStack = (tab, type) => {
  let components = [tab];

  if (!tab) {
    components = [];
  } else if (Array.isArray(tab)) {
    components = tab;
  }

  return {
    type,
    content: [{
      type: 'stack',
      content: components,
    }],
  };
};

export const rowStack = (tab) => emptyStack(tab, 'row');

export const defaultLayout = (tab) => ({ content: [{ type: 'row', content: [rowStack(tab)] }] });

const includesUrl = (urls, url, startsWith = false) => urls.includes(url)
      || (startsWith && urls.findIndex((u) => url.startsWith(`${u.replace(/\/$/, '')}/`)) >= 0);

const includesDecodedUrl = (panel, urls, startsWith = false) => {
  const decodedUrls = urls.map((url) => decodeURI(url));
  const decodedUrl = decodeURI(panel.config.componentState.url);
  return includesUrl(decodedUrls, decodedUrl, startsWith);
};

export const includesComponent = (panel, urls, startsWith = false) => (panel.isComponent
    && (includesUrl(urls, panel.config.componentState.url, startsWith)
      || includesDecodedUrl(panel, urls, startsWith))
);

export const layoutKey = (id) => `fair_layout_${id}`;

export const componentIsDirty = (component) => component.config.componentState.isDirty;

export const stackIsDirty = (stack) => stack.getItemsByType('component').some(componentIsDirty);

export const developerConfig = (splitScreen) => (
  splitScreen ? basicStack() : { type: 'column', content: [basicStack(), basicStack()] }
);

const safeTitle = (title) => (title.replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;'));

export const setPageTitle = (changeTitle, panel) => {
  const container = panel || containerShell;
  const { title } = container.config;
  const websiteName = process.env.VITE_WEBSITE_NAME;
  changeTitle(title ? `${websiteName} - ${safeTitle(title)}` : websiteName);
};

export const checkTabChanges = ({ config }, options) => ({
  newTitle: hasKey(options, 'title') && config.title !== options.title ? options.title : null,
  newKeys: Object.keys(config.componentState).filter((key) => (
    hasKey(options, key) && config.componentState[key] !== options[key])),
});

const valueTransform = (value) => {
  if (value.type === 'component') {
    return { ...value, component: 'fair', componentState: { ...value.componentState, isDirty: false } };
  }
  return undefined;
};

export const transformLayout = (config) => cloneDeepWith(config, valueTransform);

export const setTabTitle = (component, title) => component.setTitle(safeTitle(title));
